module.exports = __webpack_public_path__ + "media/img/automated-testing/benefits/benefits-img4-f8c692f0378145afb5fd0106579e6447.svg";